const switcher = document.getElementById('pricingSwitcher');
const basicPrice = document.getElementById('basicpriceswitch');
const priceLabels = document.querySelectorAll('.priceColumns__col .priceColumns__price');
const orderButtons = document.querySelectorAll('.priceColumns__col .btn');
const orderForm = document.getElementById('nf-order-form');
const formCover = document.getElementById('nf-order-form-cover');
const oderDirectButton = document.getElementById('orderDirectBtn');
const closeButton = document.getElementById('closeFormButton');

function getPrice(index, year) {
  if (year) {
    return returnValue = prices[index].jaarlijks;
  } else {
    return returnValue = prices[index].maandelijks;
  }
}

switcher.addEventListener('click', (event) => {
  event.preventDefault();

  const isYear = switcher.dataset.isYear == "true";
  switcher.dataset.isYear = !isYear;

  if (isYear) {
    basicPrice.innerHTML = "€ 59,- per maand of € 650,- per jaar";
    oderDirectButton.href = "https://samenonlineleren.nl/product/samen-online-leren-basis-pakket-per-maand/";
  } else {
    basicPrice.innerHTML = "€ 650,- per jaar of € 59,- per maand";
    oderDirectButton.href = "https://samenonlineleren.nl/product/samen-online-leren-basis-pakket-per-jaar/";
  }

  priceLabels.forEach((label, index) => {
    label.children[0].innerHTML = Object.values(getPrice(index, !isYear))[0];
    label.children[1].innerHTML = Object.values(getPrice(index, !isYear))[1];
  })

  const selectField = document.getElementById('nf-field-9');
  const options = selectField.querySelectorAll('option');
  
  if (isYear) {
    options[1].removeAttribute('selected');
    options[0].setAttribute('selected', 'selected');
  } else {
    options[0].removeAttribute('selected');
    options[1].setAttribute('selected', 'selected');
  }
});

orderButtons.forEach((button) => {
  button.addEventListener('click', (event) => {
    const selectField = document.getElementById('nf-field-7');
    const choices = selectField.querySelectorAll('option');

    const { type } = button.dataset;
    event.preventDefault();
    orderForm.classList.toggle('isActiveForm');
    formCover.classList.toggle('activeCover');

    Array.from(choices).forEach((choice) => {
      choice.removeAttribute('selected');
    })
    choices[type].setAttribute('selected', 'selected');
  })
});

formCover.addEventListener('click', () => {
  orderForm.classList.toggle('isActiveForm');
  formCover.classList.toggle('activeCover');
})

closeFormButton.addEventListener('click', () => {
  orderForm.classList.toggle('isActiveForm');
  formCover.classList.toggle('activeCover');
})